/* global angular */

angular
.module('utils.scroll', [])
.directive('smoothScroll', [
'$rootScope',
'GcUser',
'CommentService',
'PostMessageService',
'Utils',
'$document',
'$window',
function ($rootScope, GcUser, CommentService, PostMessageService, Utils, $document, $window) {
  'use strict';

  function scrollTo(event, selector, scrollContainer, duration) {
    var win = scrollContainer || $window;

    // Just before the scroll, we have to reinit all the comment's vote buttons (while clicking on yak.li link)
    CommentService.initDataVote(GcUser.getUser());

    // pass a jquery like selector
    if (typeof selector === 'string') {
      var el = $document[0].querySelector(selector);
      if (!el) {
        console.error('[scroller] element "' + selector + '" not found');
        return;
      }
      var rect = el.getBoundingClientRect();
    }

    // or just an offset from top
    else {
      var rect = { left: 0, top: selector };
    }

    duration = isNaN(duration) ? 800 : (duration || 0);

    if (Utils.inOverlay() && !Utils.isMobile()) {
      var htmlTopPadding = 8;
      window.overlayScrollbar.scroll({ y: rect.top - htmlTopPadding }, duration, 'easeOutQuart');
      return;
    }

    // When in an iframe, don't scroll the iframe but the parent frame
    if (Utils.inIframe()) {
      PostMessageService.postMessage('gc-scroll', { scrollTo: rect.top - 10, duration });
      return;
    }

    var remaining;
    var t;
    var start = Date.now();

    var from = Utils.getScrollPosition();

    if (scrollContainer) {
      rect = {
        left: rect.left + scrollContainer.scrollLeft,
        top: rect.top + scrollContainer.scrollTop,
      };
      from = {
        left: from.left + scrollContainer.scrollLeft,
        top: from.top + scrollContainer.scrollTop,
      };
    }

    requestAnimationFrame(step);

    function step() {
      remaining = Date.now() - start;
      t = remaining / duration
      t = t >= 1 ? 1 : t;

      var to = {
        top: from.top - (easeOutQuart(t) * (from.top - (rect.top - 10))),
        left: from.left - (easeOutQuart(t) * (from.left - rect.left)),
      };

      win.scrollTo(to.left, to.top);

      if (t < 1) {
        requestAnimationFrame(step);
      }
    }
  }

  // https://gist.github.com/gre/1650294
  function easeOutQuart(t) { return 1-(--t)*t*t*t }


  //requestAnimationFrame Poliyfill
  var requestAnimationFrame = $window.requestAnimationFrame || function (callback) {
    return setTimeout(function () {
      callback();
    }, 1000 / 60);
  };

  return {
    restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
    link: function ($scope) {
      $rootScope.$on("scrollTo", scrollTo);
      $scope.$on('$destroy', function () {
        $rootScope.$off("scrollTo", scrollTo);
      });
      window.debugScrollTo = scrollTo;
    }
  };
}]);
